import dayjs from 'dayjs'

export const rangePresets: { label: string; value: [dayjs.Dayjs, dayjs.Dayjs] }[] = [
  { label: '今天', value: [dayjs(), dayjs()] },
  { label: '昨天', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
  { label: '本周', value: [dayjs().startOf('week'), dayjs()] },
  { label: '本月', value: [dayjs().startOf('month'), dayjs()] },
  {
    label: '上周',
    value: [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')]
  },
  {
    label: '上个月',
    value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
  },
  { label: '过去7天', value: [dayjs().add(-6, 'd'), dayjs()] },
  { label: '过去14天', value: [dayjs().add(-13, 'd'), dayjs()] },
  { label: '过去30天', value: [dayjs().add(-29, 'd'), dayjs()] },
  // {label: '最大日期范围', value: [dayjs('2024-01-01'), dayjs()]},
];

export const rangeTomorrow = [
  { label: '本周', value: [dayjs(), dayjs().endOf('week')] },
  { label: '本月', value: [dayjs(), dayjs().endOf('month')] },
  { label: '往后7天', value: [dayjs(), dayjs().add(6, 'd')] },
  { label: '往后14天', value: [dayjs(), dayjs().add(13, 'd')] },
  { label: '往后30天', value: [dayjs(), dayjs().add(29, 'd')] },
];

export const todayRange = [dayjs(), dayjs()]

export const yesterdayRange = [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')]

export const yesterthreedayRange = [dayjs().add(-2, 'd'), dayjs()]

export const yesterdayRangeStr = [dayjs().add(-1, 'd').format('YYYY-MM-DD'), dayjs().add(-1, 'd').format('YYYY-MM-DD')]

export const thisMonth = [dayjs().startOf('month'), dayjs()]

export const pastThirtyDaysRange = [dayjs().add(-29, 'd'), dayjs()]

export const maxDaysRange = [dayjs('2024-01-01'), dayjs()]

export const maxDaysRangeStr = maxDaysRange.map(item => item.format('YYYY-MM-DD'))
//过去 7 天
export const pastSevenDaysRange = [dayjs().add(-6, 'd'), dayjs()]

// 生成32位uuid
export const uuid = () => {
  const pre = `${new Date().getTime()}${Math.random().toString().slice(2)}`
  return `${pre}${Array(32 - pre.length).fill('9').join('')}`
}